import { TBurgerLevel1, TBurgerOutput } from '@/shared/types/deprecated-types'

/** It takes an array of `TBurgerLevel1` and adapts array of `TBurgerOutput`.
 * @param burgerList
 * */
export const burgerLevel1Adapter = (burgerList: TBurgerLevel1[]): TBurgerOutput[] =>
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	burgerList.map(burgerItem => ({
		...burgerItem,
		title: burgerItem.NAME,
		link: burgerItem.SECTION_LINK,
		id: burgerItem.ID || burgerItem.NAME,
		items: burgerLevel2Adapter(burgerItem.SUB_MENU, burgerItem.ID),
		hidden: burgerItem.HIDDEN,
		icon: burgerItem.ICON
	}))
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const burgerLevel2Adapter = (burgerList: TBurgerLevel2[], parentId): TBurgerOutput[] =>
	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	burgerList.map(burgerItem => ({
		...burgerItem,
		title: burgerItem.NAME,
		link: burgerItem.SECTION_LINK,
		id: burgerItem.NAME,
		items: burgerLevel3Adapter(burgerItem.LINKS, burgerItem.NAME),
		hidden: burgerItem.HIDDEN,
		icon: null,
		count: burgerItem.COUNT,
		parentId: parentId
	}))
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const burgerLevel3Adapter = (burgerList: TBurgerLevel3[], parentId): TBurgerOutput[] =>
	burgerList.map(burgerItem => ({
		...burgerItem,
		title: burgerItem.NAME,
		link: burgerItem.LINK,
		id: burgerItem.NAME,
		items: [],
		hidden: burgerItem.HIDDEN,
		icon: null,
		parentId: parentId
	}))
